export default __webpack_public_path__ + "static/media/chat-new.6178783f.svg";